'use client'
import useGetSearchQueryURL from '@/src/hooks/srp/getSearchQueryURL'
import { Box } from '@mui/material'
import React from 'react'
import { InputsContainer } from './searchModifierInputs'

interface SearchHeaderProps {
    overlayOpen: () => void
    overlayClose: () => void
    srpResultsLoading: boolean
    jsons?: Record<string, any>
}

const SearchHeader: React.FC<SearchHeaderProps> = ({ overlayOpen, overlayClose, srpResultsLoading, jsons }) => {
    const { query } = useGetSearchQueryURL()
    return (
        <Box sx={{ py: 0.5, mb: 1 }}>
            <InputsContainer
                key={query}
                jsons={jsons}
                srpResultsLoading={srpResultsLoading}
                overlayOpen={overlayOpen}
                overlayClose={overlayClose}
            />
        </Box>
    )
}

export { SearchHeader }
export type { SearchHeaderProps }
